import { HttpParameterCodec } from '@angular/common/http';

// Custom HTML Param encoder to deal with '+' not properly encoding for timezones. Should encode all characters.
export class AllCharacterHttpParamsEncoder implements HttpParameterCodec {
    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }
    encodeValue(value: string): string {
        return encodeURIComponent(value);
    }
    decodeKey(key: string): string {
        return decodeURIComponent(key);
    }
    decodeValue(value: string): string {
        return decodeURIComponent(value);
    }
}
